import {PermissionEnum} from "../../../../../utils/enums/permission-enum.js";
import {FaArrowRightArrowLeft} from "react-icons/fa6";

const MaterialsHomeActionItems = {
  items: [
    {
      title: "Guichê",
      subTitle: "Entregas, devoluções e baixas",
      smallSub: true,
      reactIcon: FaArrowRightArrowLeft,
      permission: PermissionEnum.ERP_MATERIALS_RESPONSIBLE,
      devUrl: "materials/movements",
      url: "/material-movements",
    },
    {
      title: "Materiais em cautela",
      subTitle: "Materiais por solicitante",
      smallSub: true,
      icon: "img/materials/home/caution_material.svg",
      permission: PermissionEnum.ERP_MATERIALS_RESPONSIBLE,
      devUrl: "materials/cautions",
      url: "/material-cautions",
    },
    {
      title: "Baixas",
      subTitle: "Baixas definitivas",
      smallSub: true,
      icon: "img/materials/home/decrease_material.svg",
      permission: PermissionEnum.ERP_MATERIALS_MANAGE2,
      devUrl: "materials/decreases",
      url: "/material-decreases",
    },
    {
      title: "Indisponibilidade",
      subTitle: "Manutenção, perícia, apreensão e extravio",
      smallSub: true,
      icon: "img/materials/home/unavailable_material.svg",
      permission: PermissionEnum.ERP_MATERIALS_MANAGE2,
      devUrl: "materials/maintenances",
      url: "/material-maintenances",
    },
    {
      title: "Aquisições",
      subTitle: "Entradas de materiais",
      smallSub: true,
      icon: "img/materials/home/material_register.svg",
      permission: PermissionEnum.ERP_MATERIALS_MANAGE2,
      devUrl: "materials/registers",
      url: "/material-registers",
    },
    {
      title: "Transferência entre depósitos",
      subTitle: "Movimentação entre depósitos",
      smallSub: true,
      icon: "img/materials/home/storage_transfer.svg",
      permission: PermissionEnum.ERP_MATERIALS_MANAGE2,
      devUrl: "materials/transfers",
      url: "/material-transfers",
    },
    {
      title: "Materiais por depósito",
      subTitle: "Visão geral",
      smallSub: true,
      icon: "img/materials/home/material_x_storage.svg",
      permission: PermissionEnum.ERP_MATERIALS_RESPONSIBLE,
      devUrl: "materials/material-x-storage",
      url: "/material-x-storage",
    },
    {
      title: "Relatório",
      subTitle: "Movimentações",
      smallSub: true,
      icon: "img/sos/home/xray.svg",
      permission: PermissionEnum.REPORT_MANAGEMENT_MATERIAL_MOVEMENTS,
      devUrl: "/reports/material_movements",
      url: "/reports/material_movements",
    }
  ],

  optionsToUser: (hasPermission) => {
    return MaterialsHomeActionItems.items.filter(item =>
      (!item?.permission || hasPermission(item.permission))
    );
  }
}

export default MaterialsHomeActionItems;
